<div class="card">
    <div class="card-header text-white" [style.background-color]="'#ff4a00'">
      <div class="row">
        <div class="col-auto">
          <i class="far fa-exclamation-triangle fa-2x"></i>
        </div> 
        <div class="col my-auto">
          <h4 class="m-0 p-0">Are you sure?</h4>
        </div>
      </div>    
    </div>
    <div class="card-body p-3">
      <div class="row m-2">
        {{text}}
      </div>
      <div class="row">
        <div class="col">
          <button type="button btn-block" class="btn btn-success btn-block" (click)="activeModal.close(true)">Yes</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-danger btn-block" (click)="activeModal.dismiss(false)">No</button>
        </div>
      </div>
    </div>
  </div>
  